import classNames from 'clsx';
import styles from '../../embed.style';
import type { EmbedADT, EmbedProps } from '../../type';

export function codePen(input: EmbedADT) {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host !== 'codepen.io') return input;

  // https://codepen.io/ghaste/embed/preview/XWLJWvK?default-tabs=css%2Cresult&height=300&host=https%3A%2F%2Fcodepen.io&slug-hash=XWLJWvK
  // https://codepen.io/wakana-k/embed/YzoKyev

  let href = input.href;
  let pathname = input.pathname;
  const res = pathname.split('/');
  if (res.length > 3) {
    res[2] = 'embed';
  }
  pathname = res.join('/');
  href = input.origin + pathname;

  return (props: EmbedProps) => {
    const { width = '', height = '' } = props;

    const children = (
      <div className={classNames('w-full h-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          src={href}
          width="100%"
          height="100%"
          frameBorder="0"
          loading="lazy"
        />
      </div>
    );
    return (
      <div
        className={'w-full'}
        style={
          {
            width: width || undefined,
            '--app-markdown-video-ratio': height ? height : '320px',
          } as any
        }
        data-first={props['data-first']}
        data-last={props['data-last']}
      >
        {children}
      </div>
    );
  };
}
